import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { AppShell } from '@/features/app-shell/app-shell'
import { TranscriptionCanvas } from '@/features/app-shell/canvases/transcription-canvas'

export const Route = createFileRoute('/app/tools/transcription')({
  validateSearch: (search: Record<string, unknown>) => ({
    taskId: typeof search.taskId === 'string' && search.taskId.trim() ? search.taskId : undefined,
    clippingTaskId: typeof search.clippingTaskId === 'string' && search.clippingTaskId.trim()
      ? search.clippingTaskId
      : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: TranscriptionPage,
})

function TranscriptionPage() {
  const { taskId, clippingTaskId } = Route.useSearch()
  return <AppShell activePath="/app/ai-create"><TranscriptionCanvas initialTaskId={taskId} initialClippingTaskId={clippingTaskId} /></AppShell>
}
